import React from "react";
import { Box, DialogContent } from "@material-ui/core";
import FixedPositionDialog from "../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../elements/DialogTitleWithCloseIcon";
import I18nText from "../../../elements/I18nText";
import { PrimaryButton, ButtonsWrapper } from "../../../elements/Button";

const ExportPdfQueuedDialog = ({ onClose }) => {
  return (
    <FixedPositionDialog open={true} scroll="body" fullWidth={true}>
      <DialogTitleWithCloseIcon onClose={onClose}>
        <I18nText>devices.export.pdfQueued.title</I18nText>
      </DialogTitleWithCloseIcon>
      <DialogContent>
        <Box fontSize={14} marginBottom={2}>
          <I18nText>devices.export.pdfQueued.message</I18nText>
        </Box>
        <ButtonsWrapper
          rightButton={
            <PrimaryButton onClick={onClose}>
              <I18nText>actions.close</I18nText>
            </PrimaryButton>
          }
        />
      </DialogContent>
    </FixedPositionDialog>
  );
};

export default ExportPdfQueuedDialog;
